import type { ButtonDesignTokens, ButtonTokenSections } from '@openng/optimus-ui-themes/types/button';

export const root: ButtonTokenSections.Root = {
	borderRadius: '{border.radius.none}',
	paddingX: '1.25rem',
	paddingY: '0.75rem',
	sm: {
		fontSize: '0.875rem',
		paddingX: '1rem',
		paddingY: '0.450rem',
	},
	lg: {
		paddingX: '0.875rem',
		paddingY: '0.625rem',
	},
	label: {
		fontWeight: '400',
	},
	raisedShadow:
		'0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
};

export const colorScheme: ButtonTokenSections.ColorScheme = {
	light: {
		root: {
			primary: {
				hoverBackground: '{primary.300}',
				activeBackground: '{primary.500}',
				hoverBorderColor: '{primary.300}',
				activeBorderColor: '{primary.500}',
			},
			secondary: {
				background: 'transparent',
				hoverBackground: '{primary.50}',
				activeBackground: 'transparent',
				borderColor: '{primary.500}',
				hoverBorderColor: '{primary.300}',
				activeBorderColor: '{primary.500}',
				color: '{primary.400}',
				hoverColor: '{primary.300}',
				activeColor: '{primary.500}',
			},
			success: {
				background: '{green.600}',
				hoverBackground: '{green.400}',
				borderColor: '{green.600}',
				hoverBorderColor: '{green.400}',
			},
			warn: {
				background: '{yellow.500}',
				hoverBackground: '{yellow.400}',
				activeBackground: '{yellow.700}',
				borderColor: '{yellow.500}',
				hoverBorderColor: '{yellow.400}',
				activeBorderColor: '{yellow.700}',
				focusRing: {
					color: '{feedback.warn.accent.color}',
				},
			},
			help: {
				background: '{feedback.help.color}',
				hoverBackground: '{feedback.help.hover.color}',
				activeBackground: '{feedback.help.active.color}',
				borderColor: '{feedback.help.color}',
				hoverBorderColor: '{feedback.help.hover.color}',
				activeBorderColor: '{feedback.help.active.color}',
				focusRing: {
					color: '{feedback.help.color}',
				},
			},
			danger: {
				hoverBackground: '{red.400}',
				hoverBorderColor: '{red.400}',
			},
		},
		outlined: {
			primary: {
				activeBackground: 'transparent',
				borderColor: '{primary.400}',
			},
			success: {
				activeBackground: 'transparent',
				borderColor: '{green.500}',
				color: '{green.600}',
			},
			warn: {
				hoverBackground: '{yellow.50}',
				activeBackground: 'transparent',
				borderColor: '{yellow.600}',
				color: '{yellow.600}',
			},
			danger: {
				activeBackground: 'transparent',
				borderColor: '{red.500}',
			},
		},
	},
};

export default {
	root,
	colorScheme,
} satisfies ButtonDesignTokens;
